import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ComponentDetails} from '@emm/common-items/models/component.model';
import {Variation} from '@emm/common-items/models/variation.model';

@Component({
    selector: 'emm-components-card',
    templateUrl: './components-card.component.html',
    styleUrls: ['./components-card.component.scss']
})
export class ComponentsCardComponent {
    @Input() componentCardLabel: string;
    private _components: ComponentDetails[] = [];
    @Input() set components(value: ComponentDetails[] | string[] | null | undefined) {
        // Coerce falsy / non-array values to empty array
        if (Array.isArray(value)) {
            this._components = value as ComponentDetails[];
        } else {
            this._components = [];
        }
    }

    get components(): ComponentDetails[] {
        return this._components;
    }

    @Input() variation: Variation;
    @Input() itemName: string;
    @Input() isReadOnly = false;
    @Input() hideButtons = false;
    @Input() isSuperAdmin = false;
    @Input() isItem = false;
    @Input() isItemGrouping = false;
    @Input() isModifierGrouping = false;

    @Output() addComponent = new EventEmitter<void>();
    @Output() viewComponent = new EventEmitter<ComponentDetails | string>();

    onAddComponent() {
        this.addComponent.emit();
    }

    onViewComponent(component: ComponentDetails | string) {
        this.viewComponent.emit(component);
    }

    get showAddButton(): boolean {
        return !this.hideButtons && this.isSuperAdmin && (this.isItem || this.isItemGrouping || this.isModifierGrouping);
    }

    getComponentTag(component: ComponentDetails | string): string {
        if (typeof component === 'string') {
            return component;
        }
        return component?.tag ?? '';
    }
}
